module.exports = __webpack_public_path__ + "static/media/plumbingCard.9357a2b0.png";